import { Box } from '@chakra-ui/react';

import useGetReport from 'Domain/report/useGetReport';

import Head from './section/head';
import Tab from './section/tab';
import Filter from './section/filter';
import Table from './section/table';
import ReportProvider, { useReportState } from './state';

import styles from './styles.module.css';
import Alert from 'UiKit/alert';

const Report = () => {
  const { filterState, state } = useReportState();
  const { data, isFetching } = useGetReport({ filterState, selectedTab: state?.selectedTab });

  return (
    <Box className={styles['report__container']}>
      <Head data={data} isFetching={isFetching} />
      <Tab />
      <Filter selectedTab={state?.selectedTab} />
      <Alert {...state?.errorProps} />
      <Table data={data} isFetching={isFetching} />
    </Box>
  );
};

const ReportContainer = () => <ReportProvider children={<Report />} />;

export default ReportContainer;
